import React from 'react';
import ReactDOM from 'react-dom';
import AlertStore from './AlertStore';
import InstrumentAutosuggest from './InstrumentAutosuggest'
import './AlertList.css'
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import * as Actions from "./Actions"
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

function extractSymbol(value) {
  if(value.includes(" ") && value.includes("(") && value.includes(")") && value.includes(".")) {
    var symbol = value.split(".")[0].trim();
    return symbol;
  }
  return null;
}

function extractName(value) {
  if(value.includes(" ") && value.includes("(") && value.includes(")") && value.includes(".")) {
    var record = null;
    for(var i = 0; i <value.length; i++) {
      if(record == null && " "==value.charAt(i)) {
        record = "";
      }
      else if(record != null) {
        if (value.charAt(i) == "(") {
          return record;
        }
        else {
          record += value.charAt(i);
        }
      }
    }
    return null;
  }
  return "";
}

function extractExchange(value) {
  if(value.includes(" ") && value.includes("(") && value.includes(")") && value.includes(".")) {
    return value.split(".")[1].split(" ")[0];
  }
}

function extractCurrency(value) {
  if(value.includes(" ") && value.includes("(") && value.includes(")") && value.includes(".")) {
    return value.split("(")[1].split(")")[0];
  }
  return "";
}

function generateInstrumentString(input) {
  if(input && input.symbol) {
    return input.symbol + "." + input.exchange + " " + input.name + "(" + input.currency + ")";
  }
  return "";
}

function generateInstrumentStringFromData(symbol, exchange, name, currency) {
  if(!symbol) {
    return "";
  }
  return symbol + "." + exchange + " " + name + "(" + currency + ")";
}

class AlertList extends React.Component {

  constructor() {
    super();
  }

  componentWillMount() {
    this.getAll();
    AlertStore.on("change", () => this.getAll())
  }

  getAll() {
    this.setState({
      alerts:AlertStore.getAll()
    });
  }

  componentWillUnmount() {
     AlertStore.on("change", () => this.getAll())
     AlertStore.removeListener("change", this.getAll);
  }

  render() {
    console.log("aff" + this.state.selectedItemId)
    return (
      <div id="leftpanel">
      <Container id="alertcontainer" fixed >
      <TableContainer id="alertlist" component={Paper} background>
      <Table stickyHeader size="small" aria-label="sticky table">
      <TableHead>
         <TableRow>
           <TableCell>Instrument</TableCell>
           <TableCell align="left">Min</TableCell>
           <TableCell align="left">Max</TableCell>
           <TableCell align="left">SMA</TableCell>
           <TableCell align="left"></TableCell>
         </TableRow>
       </TableHead>
       <TableBody>
       <AlertItem mode="create" getAlertMessage = {() => this.getCurrentAlertMessage()} alert={this.state.editAlert}
       onItemSelected={(val) => this.onItemSelected(val)} selected={!this.state.selectedItemId}
       clearMessage={() => this.setState({message:""})}
         onValueChanged={(value) => {this.setState({
         editAlert: value,
       })}}/>
          {this.state.alerts.map(
            a => <AlertItem mode="edit" key={a.id} alert={a}
            selected={a.id == this.state.selectedItemId} onItemSelected={(val) => {this.onItemSelected(val);}} />)}
       </TableBody>
      </Table>
      </TableContainer>
      <div id="alertmessage">
      <TextField
      label="Type your Alert-Message"
      multiline="true" rows="2"
      fullWidth
      value = {this.state.message}
      onChange={(e) => {
          this.messageChanged(e.target.value);
      }
    }>
      </TextField>
      <a href= "mailto:theeyech.ch">created by P.Flury, contact</a>
      </div>
      </Container>
      </div>
    )
  }

  getCurrentAlertMessage() {
    return this.state.message;
  }

  messageChanged(message) {
    this.setState({
      message:message
    })
    if(this.state.selectedItemId != null) {
      var tmp = this.state.alerts.filter(o => o.id == this.state.selectedItemId);
      var alert = tmp.length == 0 ? null : tmp[0];
      //window.alert(tmp.length + "   " + this.state.alerts.length + "   " + message);
      if (alert != null) {
        alert.message = message;
        Actions.editAlert(alert);
      }
    }
  }

  onItemSelected(itemId) {
    if(itemId == this.state.selectedItemId) {
      this.setState({
      selectedItemId:itemId,
    })
    }
    else {
      this.setState({
      selectedItemId:itemId,
      message:(this.state.alerts.filter(o => o.id == itemId).length == 0 || !this.state.alerts.filter(o => o.id == itemId)[0]) ? "" : this.state.alerts.filter(o => o.id == itemId)[0].message
    })
    }
  }
}

class AlertItem extends React.Component {
  render() {
      return (
        <TableRow selected={this.props.selected} onClick={(e) => {
          if(this.muteonclick) {
            this.muteonclick=false
          }
          else {
            Actions.visualizeAlert(this.state);
          }
          this.onItemSelected(this.state.id);
        }}>
          <TableCell size="small">
          <InstrumentAutosuggest
            onChange={val => {
              this.setState({
                symbol : extractSymbol(val),
                name : extractName(val),
                exchange : extractExchange(val),
                currency : extractCurrency(val),
                completeInstrumentString: val
              }, () => this.onValueChanged());
            }}
            value = {this.state.completeInstrumentString} />
          </TableCell>
          <TableCell size="small">
            <Input type="number"
              value = {this.state.min}
              onClick={() => {
                if(!this.isClicked) {
                  AlertStore.on("coordinates_changed", this.updateMinCoordinates)
                  this.isClicked = true;
                }
              }}
              onBlur={() => {
                 AlertStore.removeListener("coordinates_changed", this.updateMinCoordinates);
                 this.isClicked = false;
                 Actions.editAlert(this.state)
                 Actions.visualizeAlert(this.state)
               }}
              onChange={(e) => {
                this.setState({min:e.target.value}, () => this.onValueChanged());
            }
          }>
            </Input>
          </TableCell>
          <TableCell size="small">
            <Input type="number"
              value = {this.state.max}
              onClick={() => {
                if(!this.isClickedB) {
                  AlertStore.on("coordinates_changed", this.updateMaxCoordinates)
                  this.isClickedB = true;
                }
              }}
              onBlur={() => {
                 AlertStore.removeListener("coordinates_changed", this.updateMaxCoordinates);
                 this.isClickedB = false;
                 Actions.editAlert(this.state)
                 Actions.visualizeAlert(this.state)
               }}
              onChange={(e) => {
                this.setState({max:e.target.value}, () => this.onValueChanged());
            }}>
            </Input>
          </TableCell>
          <TableCell size="small">
            <Input
              type="number"
              value = {this.state.sma}
              onChange={(e) => {
                this.setState({sma:e.target.value}, ()=>this.onValueChanged());
            }}>
            </Input>
          </TableCell>
          <TableCell>
          {this.props.mode=="create" ?
            <Button variant="contained" color="primary" onClick = {() => { this.onButtonClicked()}}>&oplus;</Button>
            :
            <div className="buttoncontainer">
              <button className="deleteButton" onClick = {() => {this.onButtonClicked()}} >X</button>
              <div className="arrows">
                <button className="arrowButton" onClick = {() => Actions.shiftAlert(this.state.id, "up")}>&#8679;</button>
                <button className="arrowButton" onClick = {() => Actions.shiftAlert(this.state.id, "down")}>&#x21E9;</button>
              </div>
            </div>
        }
        </TableCell>
        </TableRow>
    );
  }
  updateMinCoordinates = () =>{
    this.setState({min:Math.round((AlertStore.getCoordinates()[1] + Number.EPSILON) * 100) / 100 })
  }
  updateMaxCoordinates = () =>{
    this.setState({max:Math.round((AlertStore.getCoordinates()[1] + Number.EPSILON) * 100) / 100 })
  }
  componentWillMount() {

    if(this.props.alert) {
      this.setState({
        id:this.props.alert.id,
        type:this.props.alert.type,
        symbol: this.props.alert.symbol,
        exchange: this.props.alert.exchange,
        currency: this.props.alert.currency,
        name: this.props.alert.name,
        min: this.props.alert.min,
        max: this.props.alert.max,
        sma: this.props.alert.sma,
        completeInstrumentString:generateInstrumentStringFromData(this.props.alert.symbol, this.props.alert.exchange, this.props.alert.name, this.props.alert.currency),
        message:this.props.alert.message,
      });
    }
    else {
      this.onItemSelected();
      this.clearData();
    }
  }
  onItemSelected(e) {

    if(this.props.onItemSelected) {
      this.props.onItemSelected(e && e!=null ? e : null);
    }
  }
  onButtonClicked() {
    if(this.props.mode == "create") {
      var statecopy = {...this.state};
      statecopy.message = this.props.getAlertMessage()
      Actions.createAlert(statecopy);
      this.onItemSelected();
      this.clearData();
      let state = {
        type:"standard",
        symbol: "",
        exchange: "",
        currency: "",
        name: "",
        min: "",
        max: "",
        sma: "",
        message:"",
        completeInstrumentString:"",
      }
      if(this.props.clearMessage) {
        this.props.clearMessage();
      }
      Actions.visualizeAlert(state);
    }
    if(this.props.mode == "edit") {
      Actions.deleteAlert(this.state.id);
    }
    this.muteonclick=true
  }

  onValueChanged() {
      if(this.props.onValueChanged) {
        this.props.onValueChanged(this.state);
      }
      if(this.props.mode == "edit") {
        Actions.editAlert(this.state);
      }
      Actions.visualizeAlert(this.state);
  }

  clearData() {
    this.setState({
      type:"standard",
      symbol: "",
      exchange: "",
      currency: "",
      name: "",
      min: "",
      max: "",
      sma: "",
      message:"",
      completeInstrumentString:"",
    });
  }
}

export default AlertList
